<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        style="width: 100px"
        size="small"
        clearable
      >
        <el-option value="未提交">未提交</el-option>
        <el-option value="已提交">已提交</el-option>
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="退货单号"
        size="small"
        style="width: 150px"
        clearable
      />
      <el-input
        v-model="query.orderBillNo"
        placeholder="订单编号"
        size="small"
        style="width: 150px"
        clearable
      />
      <el-input
        v-model="query.fCkBillNo"
        placeholder="发货单号"
        size="small"
        style="width: 150px"
        clearable
      />
      <el-input
        v-model="query.fDistributor"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fCustomer"
        placeholder="客户"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_new"
      >新增</el-button>
      <el-button-export
        :url="downloadUrl"
        type="primary"
        size="small"
        style="margin: 0 10px"
      >导入模版下载</el-button-export>
      <el-button type="warning" size="small" @click="_import">导入</el-button>
      <input
        ref="fileSel"
        type="file"
        style="display: none"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      >
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_view"
      >
        <el-table-column prop="fBillNo" label="退货单号" width="155" />
        <el-table-column prop="fOrderBillNo" label="订单编号" width="140" />
        <el-table-column prop="fCkBillNo" label="送货单号" width="130" />
        <el-table-column prop="fDistributor" label="经销商" min-width="200" />
        <el-table-column prop="fCustomer" label="客户名称" min-width="200" />
        <el-table-column prop="fDes" label="退货原因" width="100" />
        <el-table-column prop="fDate" label="退货日期" width="100" />
        <el-table-column prop="fState" label="状态" width="80" />
        <el-table-column label="操作" class-name="table-oper-col" width="90">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
            <template>
              <ConfirmButton
                v-if="canDel&&scope.row.fState==='审核回退'||scope.row.fState==='暂存'"
                @confirm="_delete(scope.row)"
              >删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'
import FileDownload from './FileDownload'

export default {
  components: {
    ConfirmButton,
    FileDownload
  },
  data() {
    return {
      query: {
        fState: '未提交',

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,

      canAdd: true,
      canEdit: true,
      canDel: true
    }
  },
  mounted() {
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '009001002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '009001003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '009001004') {
        this.canDel = val.isGrant
      }
    })
  },
  activated() {
    this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '009001002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '009001003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '009001004') {
        this.canDel = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost(
        'SaleRetrun/SaleRetrunBill/SaleRetrunBillEntry',
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    _new: function() {
      var url = this.$route.path + '/0'
      this.$router.push(url)
    },
    _view: async function(row) {
      const readonly = await this.$httpPost('OrderManage/GetBillState', {
        fid: row.fid,
        key: 'ReturnGoods_create'
      }).then((res) => res.datalist)
      var url = this.$route.path + '/' + (readonly ? 'v/' : '') + row.fid
      this.$router.push(url)
    },
    _delete(row) {
      this.loading = true
      this.$httpPost('SaleRetrun/SaleRetrunBill/DeleteSaleRetrunBill', {
        fid: row.fid
      }).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          this.loading = false
          return
        }
        this.refresh()
      })
    },
    // 上传文件
    _import: function() {
      var fileSel = this.$refs.fileSel
      fileSel.onchange = () => {
        setTimeout(() => {
          fileSel.value = null
        }, 100)
        if (!fileSel.files.length) return
        var file = fileSel.files[0]
        this.$httpPostFile('Upload/SaleRetrunUpload', file).then((res) => {
          if (!res.isSuccess) {
            if (res.returnCode == '00010') {
              const h = this.$createElement
              this.$formDlg({
                title: res.message,
                readonly: true,
                formTpl: <FileDownload url={res.datalist}></FileDownload>,
                formSubmit: (formData) =>
                  this.postData(formData)
              })
            } else {
              this.$message.error(res.message)
            }
          } else {
            this.$message.success(res.message)
            this.refresh()
          }
        })
      }
      fileSel.click()
    },
    downloadUrl() {
      return this.$buildDownloadUrl(
        'Download/SaleRetrunDownload',
        {}
      )
    }
  }
}
</script>
